/** The id this targets, and the id the main landmark must carry. */
export const MAIN_CONTENT_ID = 'main-content';

/**
 * Skip-to-content affordance (V2-018C-1).
 *
 * Absent from the legacy site, where a keyboard visitor traverses the whole
 * navigation on every page before reaching any content. It is the first
 * focusable element in the document and is visually hidden until it takes
 * focus, so it costs sighted visitors nothing.
 *
 * Named `SkipToContent` rather than `SkipLink` deliberately: the link focus-ring
 * scanner in test/visualSystem.test.ts treats any component whose name ends in
 * `Link` as a link element and asserts the ring on the *call site*. This
 * component's ring belongs on the anchor it renders, below, not on every place
 * that mounts it.
 */
export function SkipToContent() {
  return (
    <a
      href={`#${MAIN_CONTENT_ID}`}
      data-testid="skip-link"
      className={
        'sr-only rounded-md bg-secondary px-4 py-2 text-sm font-medium text-secondary-foreground ' +
        'focus-visible:not-sr-only focus-visible:absolute focus-visible:left-4 focus-visible:top-4 ' +
        'focus-visible:z-50 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring'
      }
    >
      Skip to content
    </a>
  );
}
